import React from "react";
import {Route, Routes} from "react-router-dom";
import {UserCreate} from "./UserCreate";
import {UserEdit} from "./UserEdit";
import {UserImport} from "./UserImport";
import {UserList} from "./UserList";
import {UserView} from "./UserView";

export function Users() {
	return (
		<Routes>
			<Route path="new" element={<UserCreate />} />
			<Route path="import" element={<UserImport />} />
			<Route path=":username" element={<UserView />} />
			<Route path=":username/edit" element={<UserEdit />} />
			<Route index element={<UserList />} />
		</Routes>
	);
}
